import { api } from './Api';

export const deleteImage = async (data) => {
  await api.upload(`/upload/${data}`, null, { method: 'DELETE' });
};

const loadImage = (url) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    xhr.onprogress = (e) => {};

    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response;
        resolve(blob);
      } else {
        reject(new Error(`Request failed with status ${xhr.status}`));
      }
    };

    xhr.onerror = () => {
      reject(new Error('Network error occurred'));
    };
    xhr.send();
  });

export const getAllFiles = async () => {
  const response = await api.get('/upload');

  if (response?.length) {
    for (const item of response) {
      const imageUrl = `https:${item.url}?width=200&height=200`;
      // item['url'] = imageUrl;
      try {
        const blob = await loadImage(imageUrl);
        item.url = URL.createObjectURL(blob);
      } catch (error) {}
    }
    return response;
  } else return [];
};

export const getFilesByType = async (type) => {
  const response = await api.get(`/upload/type/${type}`);

  if (response?.length) {
    for (const item of response) {
      const imageUrl = `https:${item.url}?width=200&height=200`;
      try {
        const blob = await loadImage(imageUrl);
        item.url = URL.createObjectURL(blob);
      } catch (error) {}
    }
    return response;
  } else return [];
};

export const getConfigFiles = async () => {
  const response = await api.get('/upload/config');
  return response;
};

export const uploadFile = async (file) => {
  if (!file[0]) {
    throw new Error('File not attached');
  }

  const data = new FormData();

  const fileData = file[0];
  data.append('file', fileData, fileData.name);
  const { id } = await api.post('/upload');
  const response = await api.upload(`/upload/${id}`, data);

  // Convert CDN URL to blob URL for consistent format with other upload functions
  let blobUrl = response.url;
  try {
    const imageUrl = `https:${response.url}?width=200&height=200`;
    const blob = await loadImage(imageUrl);
    blobUrl = URL.createObjectURL(blob);
  } catch (error) {
    // Fallback to direct URL if blob conversion fails
    console.warn('Failed to convert URL to blob:', error);
  }

  return {
    id,
    mime: file[0].type,
    url: blobUrl, // Use blob URL for consistent display
    size: file[0].size,
    name: fileData.name,
  };
};

export const uploadDualImage = async (originalFile, editedFile) => {
  if (!originalFile || !editedFile) {
    throw new Error('Both original and edited files are required');
  }

  const data = new FormData();

  // Add original file
  data.append(
    'original_file',
    originalFile.file || originalFile,
    originalFile.name || 'original.jpg'
  );

  // Add edited file (blob)
  data.append('edited_file', editedFile, editedFile.name || 'edited.jpg');

  const { id } = await api.post('/upload');
  const response = await api.upload(`/upload/${id}/dual`, data);

  // Convert edited URL to blob URL for consistent format with other upload functions
  let editedBlobUrl = response.edited_url;
  try {
    const imageUrl = `https:${response.edited_url}?width=200&height=200`;
    const blob = await loadImage(imageUrl);
    editedBlobUrl = URL.createObjectURL(blob);
  } catch (error) {
    // Fallback to direct URL if blob conversion fails
    console.warn('Failed to convert edited URL to blob:', error);
  }

  return {
    id: response.edited_id || id, // Use edited image ID, fallback to original for backward compatibility
    mime: originalFile.mime || originalFile.type,
    url: editedBlobUrl, // Use blob URL for display (consistent with other functions)
    size: originalFile.size,
    name: editedFile.name || 'edited_image',
    // Keep original data for reference if needed
    original_id: response.original_id || id,
    original_url: response.original_url,
    edited_id: response.edited_id,
    edited_url: response.edited_url,
  };
};
